<div id="personal-area">
  <a class="personal-area-link" [routerLink]="['/personal/']">איזור אישי</a>
</div>
